export default __webpack_public_path__ + "static/media/bg.82eb8e93.png";